

































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloFamily, getDefaultAloFamily } from '@/models/alo/AloFamily'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'

@Component({
  name: 'GestionFamily'  
})
export default class GestionFamily extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newFamily = getDefaultAloFamily()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }

  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private headers = [
    { text: 'ID', value: 'id', width:70 },    
    { text: 'Inscription', value: 'famDatadd', width:150},        
    { text: 'Nom', value: 'libelle'},        
    { text: 'Ville', value: 'address.libelle', width:200},        
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get familyList() {
    return this.$store.myGetters.familyList
  }

  private get search(){
    return this.$store.myGetters.searchFamily
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_FAMILY(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortFamilyDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_FAMILY_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortFamilyBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_FAMILY_BY(value)
  }

  private get activityDic(){
    return this.$store.myGetters.activityDic
  }

  private get piscineDic(){
    return this.$store.myGetters.piscineDic 
  }

  

    
  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE();
    this.$store.myActions.ADM_PISCINE_ENSURE();
    this.loading = true    
    this.$store.myActions.ADM_FAMILY_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyFamily',params:{familyId:item.id}})    
  }

  deleteFamily(family:AloFamily) {
     if(family.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la family "${family.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_FAMILY_DELETE_REQUEST(family.id)
        } 
      })          
    } 
  }

  addFamily(){
    this.showNew = true  
    this.newFamily = getDefaultAloFamily()
  }

  save(){
    
    this.$store.myActions.ADM_FAMILY_SAVE_REQUEST(this.newFamily).then((family)=>{
      this.showNew = false
      this.openDetail(family)
    })    
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Familles',
          disabled: true,  
          to: {name:'AdminFamily'},        
          exact:true
        }
      ]      
  } 
 
}
